import CustomInput from "@Components/Basic/Input/CustomInput";
import { Grid } from "@mui/material";
import { Enquiry } from "@Services/API/IndividualApi's/Enquiry";
import { StyledGreenButton } from "@Styled/Common";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import ThankYouMessage from "./ThankYou";

interface IFormikValues {
  Name: string;
  email: string;
  mobileNumber: string;
  subject: string;
  message: string;
}

const validationSchema = yup.object({
  Name: yup.string("Enter your Name").required("Name is required"),
  email: yup
    .string("Enter your  Email")
    .email("Invalid Email")
    .required("Email is required"),
  subject: yup.string("Enter your subject").required("Subject is required"),
  mobileNumber: yup
    .number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .test(
      "len",
      "Mobile Number should be of 10 numbers length",
      (val: any) => val?.toString().length === 10
    )
    .required("A phone number is required"),
});

const ContactUs = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      Name: "",
      mobileNumber: "",
      email: "",
      subject: "",
      message: "",
    },
    validationSchema: validationSchema,

    onSubmit: async (values: IFormikValues, { resetForm }: any) => {
      const obj = {
        name: values.Name,
        mobileNumber: values.mobileNumber,
        email: values.email,
        subject: values.subject,
        message: values.message,
      };

      try {
        const response = await Enquiry.post!(obj);
        setIsFormSubmitted(true);
        resetForm({ values: "" });
        formik.initialValues;
      } catch (err) {
        console.log(err);
      }
    },
  });

  const handleClose = () => {
    setIsFormSubmitted(false);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid sx={{ marginBottom: "1rem" }}>
          <CustomInput
            fullWidth
            id="Name"
            name="Name"
            label="Name*"
            value={formik.values.Name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.Name && Boolean(formik.errors.Name)}
            helperText={formik.touched.Name && formik.errors.Name}
          />
        </Grid>
        <Grid sx={{ marginBottom: "1rem" }}>
          <CustomInput
            fullWidth
            id="email"
            name="email"
            label="Email*"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </Grid>
        <Grid sx={{ marginBottom: "1rem" }}>
          <CustomInput
            fullWidth
            id="mobileNumber"
            name="mobileNumber"
            label="Mobile Number*"
            // value={formik.values.mobileNumber}
            value={
              formik.values.mobileNumber
                ? parseInt(formik.values.mobileNumber)
                : formik.values.mobileNumber
            }
            onChange={(e) => {
              e.target.value = e.target.value.slice(0, 10);
              if (e.target.value && !Number(e.target.value)) return;
              formik.handleChange(e);
            }}
            onBlur={formik.handleBlur}
            placeholder=""
            error={
              formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)
            }
            helperText={
              formik.touched.mobileNumber && formik.errors.mobileNumber
            }
          />
        </Grid>
        <Grid sx={{ marginBottom: "1rem" }}>
          <CustomInput
            fullWidth
            id="subject"
            name="subject"
            label="Subject*"
            value={formik.values.subject}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder=""
            error={formik.touched.subject && Boolean(formik.errors.subject)}
            helperText={formik.touched.subject && formik.errors.subject}
          />
        </Grid>
        <Grid sx={{ marginBottom: "1rem" }}>
          <CustomInput
            fullWidth
            id="message"
            name="message"
            label="Message"
            multiline={true}
            rows={2}
            maxRows={4}
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder=""
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
          />
        </Grid>

        <StyledGreenButton type="submit" fullWidth>
          Submit{" "}
        </StyledGreenButton>
      </form>
      {isFormSubmitted && (
        <ThankYouMessage
          handleClose={handleClose}
          isFormSubmitted={isFormSubmitted}
        />
      )}
    </>
  );
};
export default ContactUs;
